import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {IntegrationModel} from '../../../../models/api/integrationModel';
import {dismissIntegrationRequestAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {IntegrationEnabledBanner} from './integrationEnabledBanner';

/*
 * Props.
 */

interface IntegrationEnabledBannerContainerProps {
  integration: IntegrationModel;
}

/*
 * Component.
 */

const mapDispatchToProps = makeMapDispatchToProps<IntegrationEnabledBannerContainerProps>()(
  ({integration}) => ({
    onDismissClick: () => dismissIntegrationRequestAction(integration.type),
  }),
);

export const IntegrationEnabledBannerContainer = connect(null, mapDispatchToProps)(IntegrationEnabledBanner);
